import React, { Fragment, useEffect, useState } from 'react'
import Logo from "../../images/logo.png"
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useSelector, useDispatch } from "react-redux"
import { useParams } from "react-router-dom";
import { resetPasswordAction, clearErrors } from '../../../redux/actions/userActions'
import Loader from "../../loader/loader"


const ResetPassword = () => {

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { token } = useParams();

  const { loading, isAuthenticated, error } = useSelector((state) => state.verifyEmailStore)



  const [newPassword, setNewPassword] = useState()
  const [confirmPassword, setConfirmPassword] = useState('')
  const [isSubmit, setIssubmit] = useState()
  const [showPassword, setShowPassword] = useState(false)



  const handleSubmit = (e) => {
    e.preventDefault()

    if (newPassword !== confirmPassword) {
      toast.error('passwords does not match')
      return
    }

    if (!newPassword) {
      toast.error("please Enter your password")
      return
    }

    if (!newPassword && newPassword.length < 8) {
      toast.error("please Enter atleast 8 digits for password")
      return
    }


    if (!token) {
      toast.error('invalid reset password link')
      return
    }

    const passwordsObject = {
      password: newPassword,
      confirmPassword,
    }



    dispatch(resetPasswordAction(passwordsObject, token))


    setIssubmit(true)
  }




  useEffect(() => {
    if (isAuthenticated) {
      navigate('/')
    }
    if (error && isSubmit) {
      toast.error(error)
      dispatch(clearErrors())
      setIssubmit(false)
    }

    document.title = `RESET PASSWORD`;

  }, [error, isAuthenticated, dispatch, navigate, isSubmit])



  
    useEffect(() => {
      
      document.title='RESET PASSWORD'
  
    }, [])
    



  return (
    <Fragment>
      {
        loading ? <Loader /> :
          <section className="min-h-[100vh] flex items-center justify-center p-[3vmax] signPage">
            <div className='fixed top-[2vmax] left-[2vmax]'>
              <Link to={'/'} >
                <img src={Logo} alt="" className='w-[10vmax]' />
              </Link>
            </div>
            <form className="flex items-center flex-col bg-white w-[90%] lg:w-[40%] p-[2vmax] rounded-[1vmax] shadow-1" onSubmit={handleSubmit}>
              <h4 className='text-[3vmax] lg:text-[1.8vmax] font-3 font-bold ' >Reset your
                <span className="text-[var(--color-2)]"> Password</span>
              </h4>
              <p className='pt-[0.4vmax] text-[1.6vmax] lg:text-[1.2vmax] ' >Enter a secure password and confirm it.</p>
              <div className='flex flex-col mt-[2vmax] lg:mt-[1vmax]  w-full lg:w-[80%] relative'>
                <span className='text-[1.6vmax] lg:text-[1.1vmax]' >New Password <span className='text-red-500'>*</span></span>
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  className='border-[0.15vmax] px-[2vmax] py-[0.7vmax] rounded-[0.6vmax] mt-[0.7vmax] outline-blue-400 text-[1.8vmax] lg:text-[1.1vmax]'
                />
                <button type='button'
                  className='absolute  top-[4vmax]  lg:top-[2.9vmax] right-[1.5vmax]'
                  onClick={() => setShowPassword(prev => !prev)}>
                  <i className={`fa-solid ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                </button>

              </div>
              <div className='flex flex-col mt-[1vmax] w-full lg:w-[80%]  relative'>
                <span className='text-[1.6vmax] lg:text-[1.1vmax]' >Confirm Password <span className='text-red-500'>*</span></span>
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className='border-[0.15vmax] px-[2vmax] py-[0.7vmax] rounded-[0.6vmax] mt-[0.7vmax] outline-blue-400 text-[1.8vmax] lg:text-[1.1vmax]'
                />
                <button type='button'
                  className='absolute top-[4vmax]  lg:top-[2.9vmax] right-[1.5vmax]'
                  onClick={() => setShowPassword(prev => !prev)}>
                  <i className={`fa-solid ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                </button>

              </div>
              <br />
              <div>
                <button type='submit' className='bg-[image:var(--gradient)] my-[1vmax] py-[0.7vmax] rounded-[2vmax] text-white font-bold shadow-2 block hover:scale-[0.9] px-[3vmax] text-[1.7vmax] lg:text-[1.2vmax]' >Change Password</button>
              </div>
            </form>
            <br />
            <br />
            <br />
            <br />
          </section>
      }

    </Fragment>
  )
}

export default ResetPassword